import { toastr } from "react-redux-toastr";
import {
  HELP,
  MOBILE_BREAKPOINT,
  NETWORK,
  ON_DEMAND,
  XL_BREAKPOINT
} from "../constants";

const removeItemFromLS = (key) => window.localStorage.removeItem(key);

const setItemOnLS = (key, value) => window.localStorage.setItem(key, value);

const getItemFromLS = (cname) => window.localStorage.getItem(cname);

const setUserId = (id) => {
  setItemOnLS("userId", id);
};

const showErrorSnackbar = (msg, options) => {
  toastr.clean();
  toastr.error("", msg, options);
};

const getParamFromUrl = (search, param) => {
  const searchParams = new URLSearchParams(search);
  return searchParams.get(param);
};

const randomId = () => {
  const uint32 = window.crypto.getRandomValues(new Uint32Array(1))[0];
  return uint32.toString(16);
};

const getEnabledTabs = (features) => {
  const tabs = ["scheduled"];
  if (features.ondemand) {
    tabs.push(ON_DEMAND);
  }
  if (features.network) {
    tabs.push(NETWORK);
  }
  if (features.help) {
    tabs.push(HELP);
  }
  return tabs;
};

/*
 * This method will return true if the new width received falls outside the previous width breakpoint threshold
 */
const hasChangedLayout = (prevWidth, width) => {
  const desktopJump =
    (prevWidth < XL_BREAKPOINT && width >= XL_BREAKPOINT) ||
    (prevWidth >= XL_BREAKPOINT && width < XL_BREAKPOINT);
  const mobileJump =
    (prevWidth < MOBILE_BREAKPOINT && width >= MOBILE_BREAKPOINT) ||
    (prevWidth >= MOBILE_BREAKPOINT && width < MOBILE_BREAKPOINT);
  return desktopJump || mobileJump;
};

const isAppleAndMobile = () => {
  const { userAgent } = window.navigator;
  const { platform } = window.navigator;
  const macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"];
  const iosPlatforms = ["iPhone", "iPad", "iPod"];

  return (
    (macosPlatforms.includes(platform) || iosPlatforms.includes(platform)) &&
    userAgent.includes("Mobile/")
  );
};

const bytesToBase64 = (bytes) => {
  const binString = Array.from(bytes, (byte) =>
    String.fromCodePoint(byte)
  ).join("");
  return window.btoa(binString);
};

const getStoredGeoLocation = (geoLocation) => {
  let currLocation = null;
  // Check local storage if geoLocation is null
  if (!geoLocation) {
    const lsItem = getItemFromLS("presto_geolocation");
    if (lsItem) {
      const item = JSON.parse(lsItem);
      currLocation = { ...item };
    }
  } else {
    currLocation = { ...geoLocation };
  }
  return currLocation;
};

export {
  getItemFromLS,
  setItemOnLS,
  removeItemFromLS,
  setUserId,
  showErrorSnackbar,
  getParamFromUrl,
  randomId,
  getEnabledTabs,
  hasChangedLayout,
  isAppleAndMobile,
  bytesToBase64,
  getStoredGeoLocation
};
